import { OrganizationType } from '@common/enums';
import { store } from '@frontend/configureStore';
import { fetchJson } from '../store/fetch';

export async function checkForProcessesClosedByOtherRequesterOrganizations(patientId: string) {
    if (store.getState()?.authentication?.organizationType !== OrganizationType.gpPractice) {
        return false;
    }

    const url = `/api/hasProcessesClosedByOtherRequesterOrganizations?patientId=${patientId}`;
    const result = await fetchJson(url, 'GET');

    return result.json.hasProcessesClosedByOtherRequesterOrganization;
}
